import { c as _c } from "react/compiler-runtime";
import { useParams } from "next/navigation";
import { useActionState } from "react";
import { type DelPlanMedVeilederActionState, delPlanMedVeilederServerAction } from "@/server/actions/delPlanMedVeileder";
export function useDelPlanMedVeilederAction(initialDeltMedVeilederTidspunkt) {
  const $ = _c(7);
  const {
    narmesteLederId
  } = useParams();
  let t0;
  if ($[0] !== initialDeltMedVeilederTidspunkt) {
    t0 = {
      deltMedVeilederTidspunkt: initialDeltMedVeilederTidspunkt,
      errorDelMedVeileder: null
    };
    $[0] = initialDeltMedVeilederTidspunkt;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const initialDelPlanMedVeilederActionState = t0;
  const [t1, delMedVeilederAction, isPendingDelMedVeileder] = useActionState(innerDelMedVeilederAction, initialDelPlanMedVeilederActionState);
  const {
    deltMedVeilederTidspunkt,
    errorDelMedVeileder
  } = t1;
  function innerDelMedVeilederAction(_previousState, t2) {
    const {
      planId
    } = t2;
    return delPlanMedVeilederServerAction(narmesteLederId, planId);
  }
  let t3;
  if ($[2] !== delMedVeilederAction || $[3] !== deltMedVeilederTidspunkt || $[4] !== errorDelMedVeileder || $[5] !== isPendingDelMedVeileder) {
    t3 = {
      deltMedVeilederTidspunkt,
      delMedVeilederAction,
      isPendingDelMedVeileder,
      errorDelMedVeileder
    };
    $[2] = delMedVeilederAction;
    $[3] = deltMedVeilederTidspunkt;
    $[4] = errorDelMedVeileder;
    $[5] = isPendingDelMedVeileder;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}